import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import IconView from './IconView';

const BlueprintChooser = function(props) {
  const all = props.blueprints;
  const selected = props.selected;
  const change = props.onChange;
  const selectedBp = all.find(bp => bp.ID === selected);
  const multiple = props.multiple;

  const options = all.map(bp => {
    return {
      key: bp.ID,
      value: bp.ID,
      text: bp.Name,
      content: (
        <div>
          <IconView icon={bp.Icon} />
          {bp.Name} ({bp.ID})
        </div>
      )
    };
  });

  if (multiple) {
      const renderLabel = (label) => {
        const l = all.find(bp => bp.ID === label.value);
        return {
          content: <span><IconView icon={l.Icon} />{l.Name} ({l.ID})</span>
        };
      }
      return <Dropdown selection
                       multiple
                       search
                       fluid={props.fluid}
                       options={options}
                       value={selected}
                       renderLabel={renderLabel}
                       onChange={(e,d) => change(d.value)} />
  }

  const trigger = selectedBp ? <span><IconView icon={selectedBp.Icon}/>{selectedBp.Name}</span> : <span>Select...</span>

  return <Dropdown selection
                   search
                   fluid={props.fluid}
                   options={options}
                   value={selected}
                   onChange={(e,d) => change(d.value)}
                   trigger={trigger} />
}


export default BlueprintChooser;
